import { AuctionTypeRule } from "Interfaces/auctionNotice";

const enableVerificationOfProposalCompliance = (rule: AuctionTypeRule) => rule?.generalSettings?.disputa?.habilitarVerificacaoDaConformidadeDaProposta;

export { enableVerificationOfProposalCompliance };